import PropTypes from 'prop-types';

export default ({isUserDraggedOrZoom: PropTypes.bool.isRequired,
  isReservationFlow: PropTypes.bool,});
